<template>
    <vProjectHeader
        logoColor="page"
        :categories="categories"
        :actions="dotsMenuActions"
        :project="page"
        :shareLinks="shareLinks"
        :hasChanges="hasChanges"
        :hasSnapshot="hasSnapshot"
        :hidePublish="isCreatorShown"
        :hideShare="isCreatorShown"
        @toggleCategory="toggleCategory($event)"
        @publish="$emit('publish')"
    >
        <template v-if="showHeaderMiddle" #headerMiddle>
            <div class="flex-grow">
                <HeaderMiddleControls v-if="!isCreatorShown" />
            </div>
        </template>
    </vProjectHeader>
</template>

<script>
import { CogIcon, MultipleFileIcon, PaintbrushIcon } from "@easy/ui/icons";
import { PAGE_ROUTE_NAMES } from "@/apps/page/page.routes";
import { mapState } from "vuex";
import vProjectHeader from "@/shared/views/vProjectHeader.vue";
import { usePageCreatorStore } from "@/apps/page/project/onboarding/page-creator.store";
import { storeToRefs } from "pinia";
import HeaderMiddleControls from "@/apps/page/project/HeaderMiddleControls.vue";
import { useWindowSize } from "@vueuse/core";

export default {
    name: "PageProjectHeader",
    components: {
        HeaderMiddleControls,
        vProjectHeader,
    },
    emits: ["publish"],
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        shareLinks: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        const pageCreatorStore = usePageCreatorStore();
        const { isCreatorShown } = storeToRefs(pageCreatorStore);
        const { width } = useWindowSize();

        return { isCreatorShown, width };
    },
    data() {
        return {
            openQuestions: false,
            openStyles: false,
        };
    },
    computed: {
        ...mapState(["globalUrl"]),
        ...mapState("page", ["page", "hasChanges", "hasSnapshot"]),
        showHeaderMiddle() {
            return this.width > 1024;
        },
        dotsMenuActions() {
            return this.isCreatorShown ? [] : this.actions;
        },
        categories() {
            if (this.isCreatorShown) {
                return [
                    {
                        label: this.$t("shared.creator.create_new"),
                        name: "page",
                        icon: MultipleFileIcon,
                    },
                ];
            }
            return [
                {
                    label: this.$t("page.menu.sections"),
                    icon: MultipleFileIcon,
                    name: PAGE_ROUTE_NAMES.projectSections,
                    handler: () => this.routeTo(PAGE_ROUTE_NAMES.projectSections),
                },
                {
                    label: this.$t("page.menu.settings"),
                    icon: CogIcon,
                    name: PAGE_ROUTE_NAMES.projectSettings,
                    handler: () => this.routeTo(PAGE_ROUTE_NAMES.projectSettings),
                },
                {
                    label: this.$t("page.menu.styles"),
                    name: PAGE_ROUTE_NAMES.projectStyles,
                    icon: PaintbrushIcon,
                    handler: () => this.routeTo(PAGE_ROUTE_NAMES.projectStyles),
                },
            ];
        },
    },
    methods: {
        routeTo(name, forcedView) {
            const { query } = this.$route;
            this.$router.push({ name, query: forcedView ? { ...query, view: forcedView } : query });
        },
        //FIXME: This is problem of passing computed categories
        toggleCategory(category) {
            if (category.name === "page") {
                this.openQuestions = !this.openQuestions;
            }
            if (category.name === "styles") {
                this.openStyles = !this.openStyles;
            }
        },
    },
};
</script>
